import { Attributes, DateUtils, Misc, Model, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

export enum PRNExportType {
    Liabilities = 1,
    Assets = 2
}

@NeoModel
export default class PRNCriteria extends Model.CriteriaBase {

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public runDate: Date | null = DateUtils.today();

    public exportType: PRNExportType = PRNExportType.Liabilities;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "PRN Criteria";
    }
}